import { Typography, Stack, Divider } from '@mui/material'
import type { TPublisherSong } from '@modules/types'
import { SongItem } from './SongItem'

interface SongsSelectionSectionProps {
  songs: TPublisherSong[]
  selected: number[]
  onSelect: (id: number) => void
}

export const SongsSelectionSection = ({
  songs,
  selected,
  onSelect,
}: SongsSelectionSectionProps) => (
  <>
    <Typography variant="body2" mb={4}>
      Select songs in the request that you want to share with others
    </Typography>
    <Stack divider={<Divider />} spacing={2}>
      {songs.map(song => (
        <SongItem
          key={song.id}
          song={song}
          isSelected={selected.includes(song.id)}
          onSelect={onSelect}
        />
      ))}
    </Stack>
  </>
)
